import { SetterOrUpdater, useRecoilState } from 'recoil'

import { TOrderEntryFormValues } from '../../../shipmetrics-shared/containers/OrderEntry/types'
import { templateValuesState } from './state'

export type TUseTemplateValues = {
  templateValues: TOrderEntryFormValues | null
  setTemplateValues: SetterOrUpdater<TOrderEntryFormValues | null>
}

const useTemplateValues = (): TUseTemplateValues => {
  const [templateValues, setTemplateValues] =
    useRecoilState(templateValuesState)

  return { templateValues, setTemplateValues }
}

export default useTemplateValues
